import './basic-input.sass';
import {dateMask, validationInput} from '../../../helpers/form-validation';

export default {
	props: {
		addPaddingRight: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: '',
		},
		printable: {
			required: false,
			default: false,
			type: Boolean,
		},
		formName: {
			type: String,
			default: '',
		},
		maxValue: {
			type: Number,
			default: 0,
		},
		icon: {
			type: Boolean,
			required: false,
			default: false,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		value: {
			required: false,
		},
		type: {
			required: false,
			type: String,
			default: 'text',
		},
		validationType: {
			type: String,
			default: '',
		},
		step: {
			type: Number,
		},
		minYear: {
			type: Number,
			default: 0,
		},
		socialType: {
			type: String,
			default: '',
		},
		manualError: {
			type: String,
			default: '',
		},
		name: {
			required: false,
			type: String,
		},
		tooltip: {
			required: false,
			type: Boolean,
			default: false,
		},
		tooltipText: {
			required: false,
			type: String,
		},
		isDebounced: {
			required: false,
			type: Boolean || String,
			default: false,
		},
		correctSum: {
			required: false,
			type: Boolean,
			default: false,
		},
		autocomplete: {
			required: false,
			type: String,
			default: '',
		},
		showMagnifier: {
			type: Boolean,
			required: false,
			default: false,
		},
		showRubIcon: {
			type: Boolean,
			required: false,
			default: false,
		},
		notice: {
			type: [Boolean, String],
			required: false,
			default: false,
		},
		searchInput: {
			required: false,
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			inputData: '',
			timer: false,
			errorValue: '',
			hasError: !this.disabled,
			passwordShow: false,
		};
	},

	template: /* html */`
		<label
			class="input-item"
			:class="{
				focused: inputData.length > 0 || type === 'date' || type === 'time',
				icon: icon || type === 'date' || type === 'email',
				date: type === 'date',
				login: type === 'email',
				'input-item--error': errorValue || manualError
				}"
		>
			<input
				:class="{ 'left-icon': showMagnifier, 'add-padding-right': addPaddingRight, 'active-search-input': activeSearchInput }"
				:type="passwordShow ? 'text' : type"
				:name="name"
				:autocomplete="autocomplete"
				v-model="inputData"
				:disabled="disabled"
				@blur="checkInput"
				v-on="inputListeners"
				:step="step"
				:min="minYear"
				:title="notice"
			>
			<div class="input-item__caption" :class="{ 'input-item__caption--left-icon': showMagnifier, 'input-item__caption--notice': notice }">
				{{ title }}
				<div v-if="notice" class="input-item__notice-block">
					<svg class="input-item__notice-block__icon" width="17" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.65 13.6h1.7v-1.7h-1.7v1.7zM8.5 0A8.503 8.503 0 000 8.5C0 13.192 3.808 17 8.5 17S17 13.192 17 8.5 13.192 0 8.5 0zm0 15.3a6.809 6.809 0 01-6.8-6.8c0-3.748 3.051-6.8 6.8-6.8 3.748 0 6.8 3.051 6.8 6.8 0 3.748-3.052 6.8-6.8 6.8zm0-11.9a3.4 3.4 0 00-3.4 3.4h1.7c0-.935.765-1.7 1.7-1.7.935 0 1.7.765 1.7 1.7 0 1.7-2.55 1.487-2.55 4.25h1.7c0-1.913 2.55-2.125 2.55-4.25a3.4 3.4 0 00-3.4-3.4z" fill="#8092A9"/></svg>
				</div>
			</div>
			
			<span class="input-item__error">{{ manualError || errorValue }}</span>
			<p class="input-item__printable">{{ inputData }}</p>
			<p v-if="tooltip" class="input-item__tooltip" v-html="tooltipText"></p>
			<div v-if="$slots.right" class="input-item__right">
				<slot name="right"></slot>
			</div>
			
			<template v-else>
				<svg class="input-item__editable-icon" v-if="type === 'text' && !disabled && !icon && !showMagnifier" width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M14.1489 23H10.1641C9.988 23 9.81907 22.93 9.69452 22.8055C9.56997 22.6809 9.5 22.512 9.5 22.3359V18.6262C9.5 18.5389 9.51718 18.4526 9.55055 18.372C9.58393 18.2914 9.63285 18.2182 9.69452 18.1565L19.6565 8.19452C19.7811 8.06997 19.95 8 20.1262 8C20.3023 8 20.4712 8.06997 20.5958 8.19452L24.3055 11.9042C24.43 12.0288 24.5 12.1977 24.5 12.3738C24.5 12.55 24.43 12.7189 24.3055 12.8435L14.1489 23Z" stroke="#BDBCBE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M17.5 11L21.5 15" stroke="#BDBCBE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<svg class="input-item__magnifier-icon" v-if="showMagnifier" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z" stroke="#BDBCBE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M16.4434 16.4434L20.9997 20.9997" stroke="#BDBCBE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<object class="input-item__rub-icon" v-if="showRubIcon" type="image/svg+xml" data="/sources/icons/rub.svg"></object>

				<svg class="input-item__time-icon" v-if="type === 'time'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#BDBCBE" stroke-width="2" stroke-miterlimit="10"/>
					<path d="M12 6.75V12H17.25" stroke="#BDBCBE" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
				</svg>

				<div class="input-item__password-toggler" v-if="type === 'password'" @click.prevent="passwordShow = !passwordShow">
					<svg v-if="!passwordShow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M4.5 3.75L19.5 20.25" stroke="#BDBCBE" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
						<path d="M14.5226 14.7752C13.7866 15.4441 12.8151 15.7933 11.8217 15.7459C10.8284 15.6986 9.89446 15.2586 9.22548 14.5227C8.5565 13.7868 8.20723 12.8153 8.25448 11.822C8.30174 10.8286 8.74167 9.89463 9.47749 9.22559" stroke="#BDBCBE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M6.5 6.5C2.67788 8.43552 1.5 12 1.5 12C1.5 12 4.5 18.7493 12 18.7493C13.7572 18.7633 14.9303 18.79 16.5 18" stroke="#BDBCBE" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
						<path d="M19.5571 15.8528C21.6011 14.0222 22.5 11.9998 22.5 11.9998C22.5 11.9998 19.5 5.24904 12 5.24904C11.3504 5.24798 10.7019 5.30079 10.061 5.40693" stroke="#BDBCBE" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
						<path d="M12.7056 8.31641C13.5026 8.46945 14.2285 8.8768 14.7745 9.47734C15.3204 10.0779 15.6569 10.8392 15.7335 11.6472" stroke="#BDBCBE" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
					</svg>

					<svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12 5.25C4.5 5.25 1.5 12.0007 1.5 12.0007C1.5 12.0007 4.5 18.75 12 18.75C19.5 18.75 22.5 12.0007 22.5 12.0007C22.5 12.0007 19.5 5.25 12 5.25Z" stroke="#BDBCBE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z" stroke="#BDBCBE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>

				</div>
			</template>
		</label>
	`,

	computed: {
		inputListeners: function () {
			const vm = this;
			return Object.assign({},
				this.$listeners,
				{
					input: function (event) {
						if (vm.errorValue.length) {
							vm.errorValue = '';
						}

						// Необходимо для изменения статуса кнопки сохранить в онлайн режиме
						if (vm.validationType) {
							vm.hasError = !!vm.checkValidation();
						}

						if(vm.isDebounced) {
							if(vm.timer) {
								return;
							}
							vm.timer = setTimeout(() => {
								vm.$emit('input', event.target.value);
								vm.timer = false;
							}, 1500);
						} else if(vm.correctSum) {
							const regLetters = /[^,\d]/;

							if (regLetters.test(vm.inputData)) {
								vm.inputData = vm.inputData.replace(/[^,\d]/g, '');
							}

							if (vm.maxValue > 0 && +vm.numberWithoutSpaces(vm.inputData) > vm.maxValue) {
								vm.inputData = vm.maxValue.toString();
							}
							vm.$emit('input', +vm.numberWithoutSpaces(vm.inputData));
						} else {
							vm.$emit('input', event.target.value);
						}
					},
				}
			);
		},
		activeSearchInput() {
			return this.searchInput && this.inputData.length;
		}
	},

	methods: {
		checkValidation() {
			const validation = {
				type: this.validationType,
				value: this.inputData
			};

			if (this.validationType === 'website') {
				const socials = ['facebook', 'instagram', 'vk', 'youtube'];
				if (socials.some(item => this.inputData.includes(item))) {
					const type = socials.find(item =>this.inputData.includes(item));
					validation.type = 'social';
					validation.socialType = type;
				}
			}

			if (this.validationType === 'validYear') {
				validation.minYear = this.minYear;
			}

			if (this.validationType === 'social') {
				validation.socialType = this.socialType;
			}

			return  validationInput(validation);
		},
		checkCents() {
			let trigger = this.inputData.includes(',');
			if(trigger) {
				let commaIndex = this.inputData.indexOf(',');
				let cents = this.inputData.substring(commaIndex, this.inputData.length);

				let currentCents = '';

				cents = cents.replace(/[^\d,]/g, '');

				if(cents.length === 1) {
					currentCents =  '00';
				}
				if(cents.length === 2) {
					currentCents = `${cents[1]}0`;
				}

				if (cents.length > 2) {
					currentCents = `${cents[1]}${cents[2]}`;
				}

				this.inputData = `${this.inputData.slice(0, commaIndex)},${currentCents}`;
			} else {
				!this.inputData.length ? this.inputData = 0 : '';
				this.inputData += ',00';
			}
		},

		deleteFixed() {
			this.inputData = this.inputData.substring(0, this.inputData.length - 3);
		},

		addFixed() {
			this.inputData = this.inputData + ',00';
		},

		formatSum(sum) {
			return sum.replace('.', ',');
		},

		numberWithSpaces(x) {
			x = x.replace('.', ',').replace(/[^\d,]/g, '');
			this.inputData = (x.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '));
		},

		numberWithoutSpaces(x) {
			return x.replace(/[,]/g, '.').replace(/\s+/g, '').replace(/^([^\.]*\.)|\./g, '$1');
		},

		checkInput() {
			if (this.correctSum) {
				this.checkCents();
			}

			if (this.validationType) {
				this.errorValue = this.checkValidation();
			}
		}
	},

	watch: {
		value: function(value) {
			if(value === null) {
				return;
			}
			this.inputData = value.toString();
		},
		inputData: function(value) {
			this.correctSum && this.numberWithSpaces(value);
		}
	},

	created() {
		this.hasError = this.validationType ? !this.value : false;

		if(this.value) {
			(this.type === 'date') ? this.inputData = dateMask(this.value) : this.inputData = this.value.toString();
			this.correctSum && (this.inputData = this.formatSum(this.inputData));
			(this.type === 'price') && this.checkCents();
		}
	}
};
